import {
  AppBar,
  ClickAwayListener,
  Divider,
  MenuItem,
  MenuList,
  Popper,
  Radio,
  Select,
  Tab,
  Tabs,
  Toolbar,
  Typography
} from '@material-ui/core';
import Grow from '@material-ui/core/Grow/Grow';
import Paper from '@material-ui/core/Paper';
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles
} from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import { AccountCircleOutlined, OpenInNew } from '@material-ui/icons';
import classnames from 'classnames';
import * as React from 'react';
import { connect } from 'react-redux';

import moment from 'moment';
import packageJson from '../../../../package.json';
import { ThemeContext } from '../../../hoc/Layout/Layout';
import { IScreen, IState, IUser } from '../../../models/states';
import amagi from '../../../static/icons/amagi.svg';
import { updateSelectedScreen } from '../../../store/actions/screenActions';
import { logout } from '../../../store/actions/userActions';
import history from '../../../utilities/history';
import { UserRoles } from '../../../utilities/utilities';
import ProfileInfo from '../../ProfileInfo/ProfileInfo';
import MyButton from '../MyButton';
import MyDialog from '../MyDialog/MyDialog';
import VerticalDivider from '../VerticalDivider/VerticalDivider';
import Clock from './Clock';

const styles = (theme: Theme) =>
  createStyles({
    // custom JSS
    root: {
      flexGrow: 1
    },
    appBar: theme.appBar,
    toolbar: {
      minHeight: 'inherit',
      display: 'flex',
      justifyContent: 'space-between'
    },
    mainHeading: {
      display: 'flex',
      alignItems: 'center'
    },

    tabIndicator: {
      backgroundColor: '#fff'
    },
    tabWrapper: {
      flexDirection: 'row'
    },
    labelContainer: {
      padding: 0,
      width: 'unset'
    },
    labelIcon: {
      minHeight: '3rem',
      paddingTop: 4
    },
    mainIcon: {
      marginRight: '0.5rem',
      fontWeight: 500,
      fontSize: '1.25rem'
    },
    screenInput: {
      margin: 0,
      backgroundColor: 'rgba(255,255,255,0.2)',
      padding: '0 0.75rem'
    },
    releaseInfo: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: 10
    },
    selectField: {
      background: 'rgba(255,255,255,0.3)',
      margin: '0 0.635rem',
      paddingLeft: '10px'
    },
    checkboxRoot: {
      marginLeft: '-10px',
      '&$checked': theme.checkbox.yellow
    },
    checked: {},
    textInput: {
      textTransform: 'capitalize'
    },
    textInputOperator: {
      marginLeft: 10,
      marginTop: 4,
      fontSize: '1rem',
      fontWeight: 450
    },
    selectScreenType: {
      backgroundColor: 'rgba(255,255,255,0.2)',
      textTransform: 'capitalize'
    },
    screenTypeWrapper: {
      '&:focus': {
        outline: 'none'
      }
    }
  });

class MyHeader extends React.Component<IMyHeaderProps, IMyHeaderState> {
  constructor(props: IMyHeaderProps) {
    super(props);
    this.state = {
      openMenu: false,
      anchorEl: null,
      screenType: 'screen1',
      tab: 1,
      openUserProfile: false
    };
  }
  handleToggle = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ openMenu: !this.state.openMenu, anchorEl: event.target });
  };

  handleClose = () => {
    this.setState({ openMenu: false, anchorEl: null });
  };

  logout = () => {
    history.push('/login');
    this.props.logout();
    this.handleClose();
  };
  handleTabClick = (e: React.MouseEvent<HTMLElement>, tab: number) => {
    e.preventDefault();
    this.setState({ tab });
    switch (tab) {
      case 1:
        history.push('/');
        break;
      case 2:
        history.push('/users');
        break;
      case 3:
        history.push('/screens');
        break;
      case 4:
        history.push('/agents');
        break;
      case 5:
        history.push('/switcher');
        break;
      default:
        history.push('/');
    }
  };

  componentWillMount() {
    let tab = 1;
    switch (history.location.pathname) {
      case '/':
        tab = 1;
        break;
      case '/users':
        tab = 2;
        break;
      case '/screens':
        tab = 3;
        break;
      case '/agents':
        tab = 4;
        break;
      case '/switcher':
        tab = 5;
        break;
    }
    this.setState({ tab });
  }
  handleScreenChange = (screenId: string) => {
    this.props.updateSelectedScreen(screenId, true);
  };

  handleInfraMon = () => {
    window.open(globalThis.UI_CONFIG.inframon_url, '_blank'); // to open new page
  };

  handleOpenProfile = () => {
    this.setState({ openUserProfile: false });
  };

  renderSelectValue = () => {
    return (
      <Typography
        className={classnames(this.props.classes.textInput, {
          [this.props.classes.textInputOperator]:
            this.props.user && this.props.user.role === UserRoles.OPERATOR
        })}
      >
        {this.props.selectedScreen &&
        this.props.screenMap[this.props.selectedScreen]
          ? this.props.screenMap[this.props.selectedScreen].name
          : ''}
      </Typography>
    );
  };
  static contextType = ThemeContext;

  public render() {
    const { classes, screenIds, screenMap } = this.props;
    const typeToScreenIdMap = {};
    screenIds.map((screenId: string) => {
      if (!typeToScreenIdMap[screenMap[screenId].type]) {
        typeToScreenIdMap[screenMap[screenId].type] = [screenId];
      } else {
        typeToScreenIdMap[screenMap[screenId].type].push(screenId);
      }
    });

    const user = { ...this.props.user };

    const tabs: any[] = [
      // { name: "Ingest POD", show: true },
      // { name: "Playlist POD", show: true }
    ];
    const screenTypes = ['ingest', 'playlist', 'playout'];
    // todo: add icons in the tab
    return (
      <div className={classes.root}>
        <AppBar classes={{ root: classes.appBar }}>
          <Toolbar className={classes.toolbar}>
            <div className={classes.mainHeading}>
              <div
                style={{ display: 'flex', cursor: 'pointer' }}
                onClick={e => this.handleTabClick(e, 1)}
              >
                <img
                  src={amagi}
                  alt={''}
                  style={{ marginTop: '5px', marginRight: '0.5rem' }}
                />
                <Typography
                  variant="h6"
                  color="inherit"
                  className={classes.mainIcon}
                >
                  POD
                </Typography>
              </div>
              <Clock />
              {this.state.tab === 1 ? (
                <React.Fragment>
                  <VerticalDivider
                    style={{ height: '1.2rem', margin: '0 3px' }}
                  />

                  <Select
                    id="screenId"
                    value={
                      this.props.selectedScreen ? this.props.selectedScreen : ''
                    }
                    className={classes.selectField}
                    margin="none"
                    name="screenId"
                    renderValue={() => this.renderSelectValue()}
                  >
                    {screenTypes.map((screenType: string, index: number) => {
                      if (typeToScreenIdMap[screenType]) {
                        return (
                          <div
                            key={index}
                            className={classes.screenTypeWrapper}
                          >
                            <MenuItem
                              className={classes.selectScreenType}
                              key={screenType}
                            >
                              {screenType}
                            </MenuItem>
                            {typeToScreenIdMap[screenType].map(
                              (screenId: string) => {
                                return (
                                  <MenuItem
                                    onClick={() =>
                                      this.handleScreenChange(screenId)
                                    }
                                    key={screenId}
                                    value={screenId}
                                  >
                                    <Radio
                                      checked={
                                        this.props.selectedScreen === screenId
                                      }
                                      tabIndex={-1}
                                      disableRipple
                                      classes={{
                                        root: this.props.classes.checkboxRoot,
                                        checked: this.props.classes.checked
                                      }}
                                    />
                                    {this.props.screenMap[screenId].name}
                                  </MenuItem>
                                );
                              }
                            )}
                          </div>
                        );
                      }
                    })}
                  </Select>
                </React.Fragment>
              ) : null}
            </div>
            <div className={classes.mainHeading}>
              <Tabs
                classes={{ indicator: classes.tabIndicator }}
                value={this.state.tab}
              >
                {tabs.map((tab, idx) => {
                  return (
                    <Tab
                      style={{ minWidth: '8rem' }}
                      key={tab.name}
                      label={tab.name}
                      classes={{
                        wrapper: classes.tabWrapper,
                        labelContainer: classes.labelContainer,
                        labelIcon: classes.labelIcon
                      }}
                      onClick={e => this.handleTabClick(e, idx)}
                    />
                  );
                })}
              </Tabs>
              <div onClick={e => this.handleToggle(e)}>
                <MyButton
                  style={{ fontWeight: 'normal' }}
                  btnType={'transparent'}
                >
                  <AccountCircleOutlined />
                  <span>{user.name}</span>
                  <VerticalDivider style={{ height: '1rem' }} />
                  <span>{user.role}</span>
                </MyButton>
                <Popper
                  open={this.state.openMenu}
                  anchorEl={this.state.anchorEl}
                  transition
                  disablePortal
                >
                  {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === 'bottom'
                            ? 'center top'
                            : 'center bottom'
                      }}
                    >
                      <Paper>
                        <ClickAwayListener onClickAway={this.handleClose}>
                          <MenuList>
                            <MenuItem
                              selected={this.state.tab === 1}
                              onClick={e => this.handleTabClick(e, 1)}
                            >
                              Monitor
                            </MenuItem>
                            <MenuItem
                              onClick={() =>
                                this.setState({ openUserProfile: true })
                              }
                            >
                              Profile Info
                            </MenuItem>
                            <MenuItem onClick={() => this.handleInfraMon()}>
                              Infra POD{' '}
                              <OpenInNew style={{ marginLeft: '1rem' }} />
                            </MenuItem>
                            <MenuItem
                              selected={this.state.tab === 4}
                              onClick={e => this.handleTabClick(e, 4)}
                            >
                              Agents
                            </MenuItem>
                            {/* todo:k: start: Switcher UI permissions */}
                            <MenuItem
                              selected={
                                document.location.pathname === '/switcher'
                              }
                              onClick={e => this.handleTabClick(e, 5)}
                            >
                              Switcher
                            </MenuItem>
                            {/* todo:k: Switcher UI permissions */}

                            {user.role !== UserRoles.OPERATOR ? (
                              <React.Fragment>
                                <MenuItem
                                  selected={this.state.tab === 2}
                                  onClick={e => this.handleTabClick(e, 2)}
                                >
                                  Users
                                </MenuItem>
                                <MenuItem
                                  selected={this.state.tab === 3}
                                  onClick={e => this.handleTabClick(e, 3)}
                                >
                                  Screens
                                </MenuItem>
                              </React.Fragment>
                            ) : null}
                            <MenuItem onClick={this.props.onChangeTheme}>
                              Switch to light theme
                              <ThemeContext.Consumer>
                                {value => (
                                  <Switch
                                    checked={value === 'light'}
                                    value={value}
                                  />
                                )}
                              </ThemeContext.Consumer>
                            </MenuItem>
                            <MenuItem onClick={this.logout}>Logout</MenuItem>

                            <Divider />
                            <div className={classes.releaseInfo}>
                              <Typography variant={'body1'}>
                                ⒸAmagi Media Labs Pvt Ltd
                              </Typography>
                              <Typography variant={'body1'}>
                                {`${moment().format('YYYY')} | ${
                                  packageJson.version
                                }`}
                              </Typography>
                            </div>
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  )}
                </Popper>
              </div>
            </div>
          </Toolbar>
        </AppBar>
        <MyDialog
          open={this.state.openUserProfile}
          onClose={() => this.setState({ openUserProfile: false })}
          title={'Profile Info'}
          maxWidth={'lg'}
        >
          <ProfileInfo />
        </MyDialog>
      </div>
    );
  }
}

interface IMyHeaderOwnProps extends WithStyles<typeof styles> {
  onChangeTheme: () => any;
}
interface IMyHeaderStateProps {
  user: IUser;
  screenMap: { [key: string]: IScreen };
  selectedScreen: string;
  screenIds: string[];
}
interface IMyHeaderDispatchProps {
  logout: () => void;
  updateSelectedScreen: (screenId: string, isFetchAssets: boolean) => void;
}

type IMyHeaderProps = IMyHeaderOwnProps &
  IMyHeaderStateProps &
  IMyHeaderDispatchProps;

export interface IMyHeaderState {
  openMenu: boolean;
  anchorEl: any;
  screenType: string;
  tab: number;
  openUserProfile: boolean;
}

const mapStateToProps = (state: IState) => {
  return {
    user: state.user.userInfo,
    screenMap: state.screens.screenMap,
    selectedScreen: state.screens.selectedScreen,
    screenIds: state.screens.screenIds
  };
};

const mapDispatchToProps: IMyHeaderDispatchProps = {
  logout,
  updateSelectedScreen
};

export default withStyles(styles)(
  connect<IMyHeaderStateProps, IMyHeaderDispatchProps, IMyHeaderOwnProps>(
    mapStateToProps,
    mapDispatchToProps
  )(MyHeader)
);
